module.exports = __webpack_public_path__ + "img/selected2-min.ca53f9b2.png";